import { dashboardBFF } from "../axios-instances";
import { FeatureToggleKey, GetFeatureToggleResponse } from "./types";

/**
 * Function for aquiring available licenses.
 *
 * @param config - License config
 */
export const getFeatureToggle = async (toggleKey: FeatureToggleKey) => {
  const url = `/api/feature-toggle/${toggleKey}`;
  const response = await dashboardBFF.get(url, {
    headers: {
      "Content-type": "application/json",
    },
  });

  if (response.status >= 200 && response.status < 300) {
    const toggleResponse = response.data as GetFeatureToggleResponse;

    return toggleResponse;
  }

  if (response.status === 204) {
    console.info(`Feature toggle ${toggleKey} not found (204 No Content).`);
    return undefined;
  }

  throw new Error(`Unexpected status code ${response.status} for feature toggle ${toggleKey}`);
};
